import { lazy } from 'react';
import type { RouteObject } from 'react-router';
import { RequireAuth } from '@/routes/guards';

// Páginas carregadas sob demanda (cada uma vira um pedaço separado do bundle)
const OverviewPage = lazy(() => import('./pages/Overview'));
const ModerationPage = lazy(() => import('./pages/Moderation'));
const DoctorsPage = lazy(() => import('./pages/Doctors'));
const CabinsPage = lazy(() => import('./pages/Cabins'));
const CabinDetailPage = lazy(() => import('./pages/CabinDetail'));
const RolesProfilesPage = lazy(() => import('./pages/RolesProfiles'));
const PricePage = lazy(() => import('./pages/Price'));
const AuditPage = lazy(() => import('./pages/Audit'));

/**
 * Painel do gestor (T-51..T-57). Visão geral, filas, médicos e cabines também abrem para o suporte em leitura (RN-95);
 * papéis & perfis, valor do plantão e auditoria são exclusivos do gestor.
 */
const read = (el: React.ReactNode) => <RequireAuth roles={['MANAGER', 'SUPPORT']}>{el}</RequireAuth>;
const manager = (el: React.ReactNode) => <RequireAuth roles={['MANAGER']}>{el}</RequireAuth>;

const routes: RouteObject[] = [
  { path: '/gestor', element: read(<OverviewPage />) },
  { path: '/gestor/filas', element: read(<ModerationPage />) },
  { path: '/gestor/medicos', element: read(<DoctorsPage />) },
  { path: '/gestor/cabines', element: read(<CabinsPage />) },
  { path: '/gestor/cabines/:id', element: read(<CabinDetailPage />) },
  { path: '/gestor/papeis', element: manager(<RolesProfilesPage />) },
  { path: '/gestor/valor-plantao', element: manager(<PricePage />) },
  { path: '/gestor/auditoria', element: manager(<AuditPage />) },
];
export default routes;
